// extracted by mini-css-extract-plugin
export var banner = "_j3-0";
export var settingRow = "_j3-2";
export var titleIcon = "_j3-1";